import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ContentBox from './ContentBox';
import { getMaintenanceStatus } from '../services/api';
import { useInStaffPanel } from './staff/StaffPanelContext';
import StaffSectionLayout from './staff/StaffSectionLayout';

const UPLOAD_MODE_STYLES = {
    all:        { inactive: 'bg-green-100 text-green-900 hover:bg-green-200', active: 'bg-green-600 text-white' },
    staff_only: { inactive: 'bg-orange-100 text-orange-900 hover:bg-orange-200', active: 'bg-orange-500 text-white' },
    offline:    { inactive: 'bg-red-100 text-red-900 hover:bg-red-200', active: 'bg-red-600 text-white' },
};

function AdminLayout({ children }) {
    const inStaffPanel = useInStaffPanel();

    const location = useLocation();
    const activeUrl = location.pathname;
    const [cloudUploadMode, setCloudUploadMode] = React.useState('all');

    React.useEffect(() => {
        getMaintenanceStatus()
            .then(r => { if (r?.cloudUploadMode) setCloudUploadMode(r.cloudUploadMode); })
            .catch(() => {});
    }, []);

    const adminGroups = [
        {
            header: 'Website Tools',
            links: [
                { label: 'Poll Management', url: '/housekeeping/polls' },
                { label: 'Spotlight Articles', url: '/housekeeping/spotlight-articles' },
                { label: 'Staff Team', url: '/housekeeping/staff-team' },
                { label: 'User Lookup', url: '/housekeeping/user-lookup' },
                { label: 'Manage Achievements', url: '/housekeeping/manage-achievements' },
                { label: "Remove Player's Achievements", url: '/housekeeping/remove-achievements' },
            ],
        },
        {
            header: "Frank's Shack",
            links: [
                { label: 'Shop Items', url: '/housekeeping/shop-items' },
                { label: 'Shop Discounts', url: '/housekeeping/shop-discounts' },
                { label: 'Purchase Log', url: '/housekeeping/shop-purchases' },
            ],
        },
        {
            header: 'Core Settings',
            links: [
                { label: 'Maintenance Mode', url: '/housekeeping/maintenance' },
                { label: 'Site Themes', url: '/staff/admin/themes' },
                { label: 'Session Management', url: '/housekeeping/sessions' },
                { label: 'Toggle Upload Allowance', url: '/housekeeping/cloud-upload', uploadMode: true },
                { label: 'FranklyCloud Partners', url: '/housekeeping/cloud-partners' },
            ],
        },
        {
            header: 'Games',
            links: [
                { label: 'Slimeburger Spin', url: '/housekeeping/slimespins' },
            ],
        },
        {
            header: 'AskFrank',
            links: [
                { label: 'Overview', url: '/staff/admin/askfrank' },
                { label: 'Sources', url: '/staff/admin/askfrank/sources' },
                { label: 'Knowledge', url: '/staff/admin/askfrank/knowledge' },
                { label: 'Front Page', url: '/staff/admin/askfrank/frontpage' },
                { label: 'Lab', url: '/staff/admin/askfrank/lab' },
            ],
        },
        {
            header: 'Misc',
            links: [],
        },
    ];

    if (inStaffPanel) return <StaffSectionLayout>{children}</StaffSectionLayout>;

    return (
        <div className="w-full min-h-screen p-4 lg:p-6">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6">
                <div className="lg:col-span-4">
                    {adminGroups.filter(group => group.links.length > 0).map(group => (
                        <ContentBox key={group.header} theme="default" tint="red" header={group.header}>
                            <div className="flex flex-col gap-2">
                                {group.links.map((link, index) => {
                                    const isActive = activeUrl === link.url;
                                    if (link.uploadMode) {
                                        const modeStyle = UPLOAD_MODE_STYLES[cloudUploadMode] || UPLOAD_MODE_STYLES.all;
                                        return (
                                            <Link
                                                key={index}
                                                to={link.url}
                                                className={`font-['Jersey_10'] uppercase text-[16px] tracking-[1px] px-3 py-2 rounded transition-all
                                                    ${isActive ? modeStyle.active : modeStyle.inactive}`}
                                                style={{ boxShadow: '0 2px 0 0 rgba(0, 0, 0, 0.2)' }}
                                            >
                                                {link.label}
                                            </Link>
                                        );
                                    }
                                    return (
                                        <Link
                                            key={index}
                                            to={link.url}
                                            className={`font-['Jersey_10'] uppercase text-[16px] tracking-[1px] px-3 py-2 rounded transition-all
                                                ${isActive
                                                ? 'bg-maroon text-white'
                                                : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
                                            }`}
                                            style={{
                                                boxShadow: '0 2px 0 0 rgba(0, 0, 0, 0.2)'
                                            }}
                                        >
                                            {link.label}
                                        </Link>
                                    );
                                })}
                            </div>
                        </ContentBox>
                    ))}
                </div>

                <div className="lg:col-span-8">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default AdminLayout;